import { useState, useEffect, useContext } from 'react';
import { Card, Chip, Typography, TextField, Grid, Button, Box, Tooltip, IconButton, Modal, InputAdornment, Skeleton, Switch, useTheme, useMediaQuery, Paper } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import Swal from 'sweetalert2';
import { DataGrid, } from '@mui/x-data-grid';
import { useForm, Controller } from 'react-hook-form';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import SearchIcon from '@mui/icons-material/Search';
import NoRowsLayout from '../../components/Layout/NoRowsLayout';
import { useNavigate } from 'react-router-dom';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { Helpers } from '../../services/Helpers';
import { PermissionGuard } from '../../components/PermissionGuard';
import PageHeaderLayout from '../../components/Layout/PageHeaderLayout';
import { ArrowBack, Close, Search } from '@mui/icons-material';
import Loading from '../../components/Loader/Loading';
import ExportAll from './ExportAll';
import QuickSearchTool from '../../components/QuickSearch/QuickSearchTool';
// import Filter from './filterAndExport/Filter';
import { LocalStore } from '../../storage/authStore';
import noImage from '../../assets/images/no_image_available.png'
import { BrandServices } from './BrandServices';
import MultiColumnFilter from '../../components/Filter/MultiColumnFilter';
import useResponsive from '../../hooks/useResponsive';
import { usePermission } from '../../hooks/usePermission';
import { BrandContext } from '.';
import { set } from 'zod';
import ViewDetails from './ViewDetails';
export default function BrandList() {
    const { brandInitialData,brandData,setBrandData,fetchBrandList,brandList,paginationModel,setPaginationModel,totalRowCount,loadingList,selectedBrandData, setSelectedBrandData} = useContext(BrandContext);
    
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const loggedUser = LocalStore.getLoggedUserDetails();
    const {isSm} = useResponsive();
    const userPermissions = usePermission("brand");
    const showActionColumn = userPermissions.canEdit;
    // console.log('loggedUser', loggedUser);
    const navigate = useNavigate();
    const { control, handleSubmit, reset, setValue, getValues, formState: { errors } } = useForm({
        mode: "onChange",
        defaultValues: {
          searchKey: "",
        }
    });
    
    const [deleteRowData, setDeleteRowData] = useState({});

   /************************  Manage Use Effect **************************** */
    useEffect(() => {
        fetchBrandList();
    }, [paginationModel, deleteRowData]);    

    const handleStatusChange = async (brand) => {
        const result = await Swal.fire({
          title: 'Are you sure?',
          text: `You want to change the status form ${brand.isActive ? 'Active' : 'In-Active'} to ${brand.isActive ? 'In-Active' : 'Active'} of this service!`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, change it!',
          cancelButtonText: 'No, keep it'
        });
        if (result.isConfirmed) {
          // processing screen 
          Swal.fire({
            title: 'Processing',
            html: 'Please wait...',
            didOpen: () => {
              Swal.showLoading();
            },
          });
          const modifiedData = {
            title:brand.title,
            image:brand.image,
            bLevel:brand.bLevel,
            isActive: !brand.isActive
          }
          try {
            const response = await BrandServices.updateBrand(modifiedData,brand.id);
            if (response.success == '1') {
              Swal.fire('Status Changed!', '', 'success');
              setDeleteRowData(response.data);
            } else {
              Swal.fire('Failed!', '', 'error');
            }
          } catch (error) {
            Swal.fire('Failed!', '', 'error');
          }
        }
    }

    const [viewBrandDetails, setViewBrandDetails] = useState({
        open: false,
        brandData: null
    });

    const fetchBrandDetails= async(brandId)=>{
      Swal.fire({
        title: 'Loading...',
        html: 'Please wait while fetching Selected Brand details ...',
        didOpen: () => {
          Swal.showLoading();
        },
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
      })
      try {
          const brandDetailsResponse = await BrandServices.fetchBrandData(brandId);
          // console.log("category list Response:",categoryListResponse);
          if(brandDetailsResponse.success == '1'){
            setViewBrandDetails({
              open: true,
              brandData: brandDetailsResponse.data || null,
            });
          }else{
            setViewBrandDetails({
              open: false,
              brandData: null
            })
            Swal.fire({
              title: 'Error!',
              text: brandDetailsResponse.message || 'Something went wrong while fetching brand details',
              icon: 'error',
              confirmButtonText: 'OK'
            })
          }
          Swal.close();
      } catch (error) {
        console.log("error in fetching brand details",error);
        Swal.fire({
          title: 'Error!',
          text: error.message || 'Something went wrong while fetching brand details',
          icon: 'error',
          confirmButtonText: 'OK'
        })
      }
    }
    const viewRelatedServices = (brandId) => {
      fetchBrandDetails(brandId);
    }

    /************************  Table Column Manage **************************** */
    const columns = [
        {
          field: 'title',
          headerName: 'Brand',
          headerAlign: 'center',
          flex: 2,
          sortable: false,
          // filterable: false,
          valueGetter: (params) => {
            // Join all subcategory titles into a single searchable string
            const parentServiceTitle = params.row.parentServiceId > 0 && params.row.parentService?.title || '';
            const title = params.row.title;
            return parentServiceTitle ? `${title} (${parentServiceTitle})` : title;
          },
          renderCell: (params) => (
            <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
              <Box sx={{ width: '15%' }}>
                {params.row.image ? (
                  <img
                    //   src={params.row.image} 
                    src={`${Helpers.ImagePathUrl()}/brands/sm/${params.row.image}`}
                    alt={params.row.title}
                    style={{ width: '2rem', height: '2rem', objectFit: 'cover' }}
                  />
                ) : (
                  // <Skeleton variant="rectangular" width={35} height={35} animation={false} />
                  <img
                    //   src={params.row.images} 
                    src={noImage}
                    alt={params.row.title+'image_not_available'}
                    style={{ width: '2rem', height: '2rem', objectFit: 'cover' }}
                  />
                )}
              </Box>
              <Box display={'flex'} flexDirection={'column'} justifyContent={'center'} alignItems={'center'} sx={{ ml: 1, width: '85%' }}>
                <Typography variant="body2" sx={{ fontWeight: 600, color: '#3e3e3e', textAlign: 'center', fontSize: '.7rem' }}>{params.row.title}
                  {(loggedUser?.role.title == 'Admin' || loggedUser?.role.title == 'Super Admin') &&
                    <Box component={'span'} sx={{ fontSize: '.6rem', fontWeight: 500, color: '#1976d2' }}>
                      {`(${params.row.id})`}
                    </Box>
                  }
                </Typography>
                {params.row.parentServiceId > 0 && <Typography variant="caption" sx={{ justifyContent: 'center', alignItems: 'center', fontSize: '.5rem' }}>{`(${params.row.parentService?.title || ''})`}</Typography>}
              </Box>
            </Box>
          ),
        },
        {
          field: 'bLevel',
          headerName: 'Brand Level',
          headerAlign: 'center',
          flex: 1,
          sortable: false,
          renderCell: (params) => (
            <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
              <Box display={'flex'} flexDirection={'column'} justifyContent={'center'} alignItems={'center'} sx={{ ml: 1, width: '85%' }}>
                <Typography variant="body2" sx={{ fontWeight: 600, color: '#3e3e3e', textAlign: 'center', fontSize: '.7rem' }}>
                  {params.row.bLevel}
                </Typography>
            </Box>
            </Box>
          ),
        },
        {
          field: 'status',
          headerName: 'Status',
          headerAlign: 'center',
          flex: 1,
          sortable: false,
          renderCell: (params) => (
            <Box sx={{ textAlign: 'center', width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
              <Switch
                disabled={selectedBrandData}
                size='small'
                checked={params.row.isActive}
                onChange={() => handleStatusChange(params.row)}
                sx={{
                  '& .MuiSwitch-switchBase.Mui-checked': {
                    color: 'success.main',
                  },
                  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                    backgroundColor: 'success.main'
                  },
                  '& .MuiSwitch-switchBase': {
                    color: 'error.main',
                  },
                  '& .MuiSwitch-track': {
                    backgroundColor: 'error.main'
                  }
                }}
                inputProps={{ 'aria-label': 'controlled' }}
              />
              <Chip
                label={params.row.isActive ? 'Active' : 'Inactive'}
                color={params.row.isActive ? 'success' : 'error'}
                size="small"
                sx={{ fontSize: '0.65rem', height: 'fit-content' }}
              />
            </Box>
          ),
        },
        {
          field: 'actions',
          headerName: 'Actions',
          headerAlign: 'center',
          flex: 1,
          filterable: false,
          sortable: false,
          renderCell: (params) => (
            <Box sx={{ p: 1, display: 'flex', gap: 1, justifyContent: 'center', alignItems: 'center', width: '100%' }}>
              <IconButton
                sx={{ color: "blue", }}
                onClick={() => viewRelatedServices(params.row.id)}
                size="small">
                <RemoveRedEyeIcon sx={{ fontSize: '0.95rem' }} />
              </IconButton>
              <PermissionGuard feature='service' permission='canEdit'>
                <IconButton
                    disabled={selectedBrandData}
                    onClick={() => setSelectedBrandData(params.row)}
                    size="small" color='warning'
                >
                  <EditIcon sx={{ fontSize: '0.95rem' }} />
                </IconButton>
              </PermissionGuard>
              {/* <IconButton onClick={() => deleteService(params.row.id)} size="small">
                  <DeleteIcon />
                </IconButton> */}
            </Box>
          ),
        },
    ];
    /************************  Action Handler Related table row **************************** */
    const handlePaginationChange = (newPagination) => {
        setPaginationModel({
          ...paginationModel,
          page: newPagination.page,
          pageSize: newPagination.pageSize
        });
    }

    function onSubmit(data) {
        const filtersData = getValues();
        setPaginationModel({
          ...paginationModel,
          filters: {
            ...paginationModel.filters,
            searchKey: filtersData.searchKey,
          }
        });
    }

    const clearFilters = () => {
        reset({
          searchKey: "",
        });
        setPaginationModel({
          ...paginationModel,
          filters: {
            ...paginationModel.filters,
            searchKey: "",
            sortBy: 'createdAt',
            sortType: 'desc',
            filterOptions: []
          }
        });
    
        // Trigger clear for MultiColumnFilter
        setClearMultiFilter(true);
    
        // Reset the clear trigger after a short delay
        setTimeout(() => setClearMultiFilter(false), 100);
    }

    /************************  Advance Filter **************************** */


    const [clearMultiFilter, setClearMultiFilter] = useState(false);
    
    const handleApplyFilter = (filterData) => {
        // Process filter data
        console.log(filterData);
        setPaginationModel({
          ...paginationModel,
          page: 0, // Reset to first page when applying new filters
          filters: {
            ...paginationModel.filters,
            // Convert MultiColumnFilter options to a format your backend can understand
            filterOptions: filterData.filterOption.filter(filter => filter.fieldName && filter.value) // Remove empty filters
          }
        });
    }
    
    /************* quick search related **************/
    // Properly structured filter model
    const [filterModel, setFilterModel] = useState({
        items: [],
        quickFilterValues: []
    });

    /******************* Sorting model  ******************************/
    const [sortModel, setSortModel] = useState([
        {
          field: paginationModel.filters.sortBy,
          sort: paginationModel.filters.sortType,
        },
    ]);
    
    const handleSortingChange = (newSortModel) => {
        if (newSortModel && newSortModel.length > 0) {
          setSortModel(newSortModel);
          setPaginationModel(prev => ({
            ...prev,
            filters: {
              ...prev.filters,
              sortBy: newSortModel[0].field,
              sortType: newSortModel[0].sort
            }
          }));
        }
    }
    const filterableColumns = [
    //   {
    //     key: 'id',
    //     label: 'ID',
    //     type: 'number'
    //   },
      {
        key: 'title',
        label: 'Brand Name',
        type: 'text'
      },
      
      {
        key: 'bLevel',
        label: 'Brand Level',
        type: 'select',
        options: [
            { value: 'ultrapremium', label: 'Ultra Premium' },
            { value: 'premium', label: 'Premium' },
            { value: 'midtier', label: 'Mid Tier' },
            { value: 'value', label: 'Value' },
            { value: 'low', label: 'Low' }
        ]
      }
    ];
    return (
      <>
        <Card sx={{ minWidth: "100%", marginBottom: ".5%"}}>
          <Box sx={{p:'.5% 1%',border:'2px solid lightGray',bgcolor:'lightGray'}}>
            <Typography sx={{fontWeight:600,fontSize:'0.85rem'}} >Brand List</Typography>
          </Box>
          <Box sx={{ overflow: "auto" }}>
              {loadingList && <Loading />}
              <Box sx={{ width: "100%", display: "table", tableLayout: "fixed", backgroundColor: "#fff", borderRadius: '.5rem' }}>
              <Box sx={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center', px: '1%' }}>
                  <Box sx={{ display: 'flex', gap: 1 }}>
                  <MultiColumnFilter
                      filterableColumns={filterableColumns}
                      onApplyFilter={handleApplyFilter}
                      externalClear={clearMultiFilter}
                      defaultFilterOptions={paginationModel.filters.filterOptions}
                  />
                  {/* <ExportAll 
                      paginationModel={paginationModel} 
                      // columns={columns} 
                      // statusOptions={statusOptions} 
                  /> */}
                  </Box>
                  <Box sx={{display:{xs:'none',sm:'block'}}}>
                      {/* <QuickSearchTool filterModel={filterModel} setFilterModel={setFilterModel} /> */}
                      <Grid container spacing={1} sx={{ p: '1%' }} component={'form'} onSubmit={handleSubmit(onSubmit)}>
                          <Grid item xs={9} lg={8}>
                              <Controller
                              name="searchKey"
                              control={control}
                              // defaultValue=""
                              render={({ field }) => (
                                  <TextField
                                  {...field}
                                  placeholder="Search here....."
                                  // label="Search"
                                  size="small"
                                  fullWidth
                                  sx={{
                                      '& .MuiOutlinedInput-root': {
                                      paddingLeft: '0px',
                                      }
                                  }}
                                  InputProps={{  // Changed from slotProps to InputProps
                                      inputProps: {
                                      style: {
                                          height: '0.6rem',
                                          textTransform: 'uppercase',
                                          fontSize: 'x-small'
                                      },
                                      },
                                      startAdornment: (
                                      <InputAdornment position="start">
                                          <IconButton>
                                          <Search sx={{ fontSize: 'x-small' }} />
                                          </IconButton>
                                      </InputAdornment>
                                      ),
                                  }}
                                  />
                              )}
                              />
                          </Grid>
                          <Grid item xs={3} sm={4} >
                              <Tooltip title="Search" sx={{ ml: 1, p: 0 }}>
                              <IconButton
                                  size='small'
                                  color="primary"
                                  type="submit"
                                  sx={{ border: "1px solid", borderRadius: "7px", padding: "1%", ml: 1 }}
                              >
                                  <SearchIcon sx={{ fontSize: '.85rem' }} />
                              </IconButton>
                              </Tooltip>
                              <Tooltip title="Clear All Filters">
                              <IconButton
                                  size='small'
                                  color="primary"
                                  sx={{ marginLeft: "10px", border: "1px solid", color: "#f00", borderRadius: "7px", padding: "1%" }}
                                  onClick={clearFilters}
                              >
                                  <RestartAltIcon sx={{ fontSize: '.85rem' }} />
                              </IconButton>
                              </Tooltip>
                          </Grid>
                      </Grid>
                  </Box>
              </Box>
              <DataGrid
                  rows={brandList}
                  columns={columns.map((col) => ({
                  ...col,
                  // flex: col.flex || 1, // Ensure columns resize dynamically
                  minWidth: isSmallScreen && (col.minWidth || 150), // Set a minimum width to avoid overlap
                  }))}
                  getRowId={(row) => row.id}
                  //checkboxSelection={true}
                  rowCount={totalRowCount}  // Use the length of the filtered list
                  pageSizeOptions={[5, 10, 20, 50, 100]}
                  paginationModel={paginationModel}
                  paginationMode="server"
                  onPaginationModelChange={handlePaginationChange}

                  filterModel={filterModel}

                  sortingMode="server"
                  sortModel={sortModel}
                  onSortModelChange={handleSortingChange}

                  loading={loadingList}

                  disableColumnMenu
                  disableRowSelectionOnClick
                  slots={{
                  // toolbar: GridToolbar,                        
                  loadingOverlay: Loading,
                  noRowsOverlay: NoRowsLayout,
                  }}
                  autoHeight
                  getRowHeight={() => 'auto'}
                  sx={{
                  '& .MuiDataGrid-cell': {
                      border: 1,
                      borderRight: 0,
                      borderTop: 0,
                      borderColor: 'lightgrey',
                      display: 'flex',
                      alignItems: 'center',
                      // justifyContent: 'center',
                  },
                  '& .MuiDataGrid-columnHeaders': {
                      borderBottom: '2px solid rgba(224, 224, 224, 1)',
                      borderTop: '2px solid rgba(224, 224, 224, 1)',
                      fontWeight: 600,
                      fontSize: '0.75rem',
                      p: 0,
                      height: 'fit-content',
                      minHeight: '0 !important',
                      height: '2rem'
                  },
                  '& .MuiDataGrid-columnHeader': {
                      borderLeft: '1px solid rgba(224, 224, 224, 1)',
                      '&:last-child': {
                      borderRight: 'none',
                      },
                  },
                  '& .MuiDataGrid-columnHeaderTitle': {
                      fontWeight: 600,
                      color: '#3e3e3e'
                  },
                  '& .MuiDataGrid-row': {
                      '&:last-child .MuiDataGrid-cell': {
                      borderBottom: '1px solid rgba(224, 224, 224, 1)',
                      },
                      '& .MuiDataGrid-cell:last-child': {
                      borderRight: 'none',
                      },
                  },
                  '& .MuiDataGrid-columnSeparator': {
                      display: 'none',
                  },
                  }}
              />
              </Box>
          </Box>
        </Card>
        {/* =======  view Brand Detail's Modal ======= */}
        <Modal
          open={viewBrandDetails.open}
          // onClose={() => setViewBrandDetails({ open: false, brandData: null })}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: isSm ? '90%' : '75%',
            bgcolor: 'background.paper',
            // border: '2px solid #000',
            boxShadow: 24,
            // p: 2,
            maxHeight: '80vh',
            overflowY: 'auto'
          }}>
            {viewBrandDetails.brandData ? (
              <>
                <Box sx={{display:'flex',justifyContent:'space-between',alignItems:'center',p:'.5% 1%',border:'2px solid lightGray',bgcolor:'lightGray'}}>
                  <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>{`Brand Detail's`}</Typography>
                  <IconButton size='small' sx={{p:0}} onClick={() => setViewBrandDetails({ open: false, brandData: null })}><Close sx={{bgcolor:'red',color:'#fff'}}/></IconButton>
                </Box>
                <ViewDetails selectedBrandData={viewBrandDetails.brandData} />
              </>
            ) : null}
          </Box>
        </Modal>
        
      </>
    )
}